import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

export interface INewsPhoto {
  src: string;
  alt: any;
  title: string;
}

export interface INews {
  title: string;
  url: string;
  photo: INewsPhoto;
  field_content_category: string;
  field_publish_date: string;
}

export class GenericNewsStore extends EntitiesStore<INews> {
  constructor(http: HttpClient, public endpoint:string) {
    super('null', http);
  }

  /**
   *
   * {@inheritdoc}
   * @returns {Observable<any>}
   * @memberof AthletePhotosStore
   */
  getRequest(params: any, request_more: boolean = false): Observable<any> {
    this.loadingRef = true;
    const url = environment.production ? environment.drupal_api + this.endpoint : this.endpoint;
    return this.http.get(url, {
      params: params
    })
      .pipe(
        catchError((e) => of([])),
        tap((next: INews[]) => {
            this.dataStream.next(next);
            this.data = next;
          this.loadingRef = false;
          this.requestMore = false;
        }));
  }



}
